import React, { useRef } from 'react';
import './App.css'; // Main app styles
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import AboutUs from './components/AboutUs/AboutUs';
import Services from './components/Services/Services';
import Members from './components/Members/Members';
import ClientSection from './components/Client/Client'; // Renamed Client to ClientSection for clarity
import ContactUs from './components/ContactUs/ContactUs';
import Footer from './components/Footer/Footer';
import { SECTION_IDS } from './constants';

function App() {
  const sectionRefs = {
    [SECTION_IDS.ABOUT]: useRef(null),
    [SECTION_IDS.SERVICES]: useRef(null),
    [SECTION_IDS.MEMBERS]: useRef(null),
    [SECTION_IDS.CLIENTS]: useRef(null),
    [SECTION_IDS.CONTACT]: useRef(null),
    // Add other sections here if they need to be scrollable-to
  };

  const scrollToSection = (sectionId) => {
    const ref = sectionRefs[sectionId];
    if (ref && ref.current) {
      ref.current.scrollIntoView({ behavior: 'smooth' });
    } else {
      // Fallback for sections without specific refs, or if ID is direct (e.g. Hero)
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <div className="App">
      <Header scrollToSection={scrollToSection} />
      <main>
        {/* Hero section typically doesn't need a ref for scrolling *to* it via header, but can have an ID */}
        <Hero scrollToSection={scrollToSection} />

        {/* Assign refs to sections that need to be scrolled to */}
        <div ref={sectionRefs[SECTION_IDS.ABOUT]} id={SECTION_IDS.ABOUT}>
          <AboutUs />
        </div>
        <div ref={sectionRefs[SECTION_IDS.SERVICES]} id={SECTION_IDS.SERVICES}>
          <Services />
        </div>
        <div ref={sectionRefs[SECTION_IDS.CLIENTS]} id={SECTION_IDS.CLIENTS}>
          <ClientSection />
        </div>
        <div ref={sectionRefs[SECTION_IDS.MEMBERS]} id={SECTION_IDS.MEMBERS}>
          <Members />
        </div>
        <div ref={sectionRefs[SECTION_IDS.CONTACT]} id={SECTION_IDS.CONTACT}>
          <ContactUs />
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default App;
